import { render, staticRenderFns } from "./dap-project-empty.page.vue?vue&type=template&id=04492bfa&scoped=true&functional=true"
var script = {}
import style0 from "./dap-project-empty.page.vue?vue&type=style&index=0&id=04492bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "04492bfa",
  null
  
)

export default component.exports